/**
 * 8-direction facing from movement (matches shared `NPC_DIRECTIONS` / 45° sectors from +x).
 */
export const PLAYABLE_DIR_ORDER = [
  "east",
  "south-east",
  "south",
  "south-west",
  "west",
  "north-west",
  "north",
  "north-east",
] as const;

export type PlayableDir = (typeof PLAYABLE_DIR_ORDER)[number];

export function velocityToPlayableDir(ux: number, uy: number): PlayableDir {
  const deg = (Math.atan2(uy, ux) * 180) / Math.PI;
  const norm = (deg + 360) % 360;
  const idx = Math.floor((norm + 22.5) / 45) % 8;
  return PLAYABLE_DIR_ORDER[idx];
}
